import React, { useState } from "react";
import { Chip, MenuItem, Menu } from "@mui/material";
import styled from "@emotion/styled";
import { ExpandMore } from "@mui/icons-material";
import { statusSeverity } from "../utils/statusColors";

const ManagerDropDownItem = styled(MenuItem)(({ theme }) => ({
    textDecoration: "none",
    color: theme.palette.text.primary,
    "&:hover": {
        backgroundColor: theme.palette.action.hover,
    },
}));

const PriorityChip = ({ priority, onChange = null }) => {
    const [statusMenuAnchorEl, setStatusMenuAnchorEl] = useState(null);
    const priorityMenu = ['Highest', 'High', 'Medium', 'Low', 'Lowest'];
    const chipColor = statusSeverity("priority", priority);


    const handlePriorityMenuClick = (event) => {
        setStatusMenuAnchorEl(event.currentTarget);
    };

    const handlePriorityMenuChildClick = (event) => {
        setStatusMenuAnchorEl(event.currentTarget.parentElement);
    }

    const handlePriorityMenuClose = () => {
        setStatusMenuAnchorEl(null);
    };

    return (
        <>
            <Chip color={chipColor} size="small" variant="outlined" label={priority} {...(onChange && {
                deleteIcon: <ExpandMore />,
                onClick: handlePriorityMenuClick,
                onDelete: handlePriorityMenuChildClick
            })} />
            {onChange && (
                <Menu anchorEl={statusMenuAnchorEl} open={Boolean(statusMenuAnchorEl)} onClose={handlePriorityMenuClose}>
                    {priorityMenu.map((priorityOption) => (
                        <ManagerDropDownItem key={priorityOption} onClick={() => {
                            onChange({ target: { value: priorityOption } });
                            handlePriorityMenuClose();
                        }}>
                            {priorityOption}
                        </ManagerDropDownItem>
                    ))}
                </Menu>
            )}
        </>
    );
}

export default PriorityChip;